module.exports = __webpack_public_path__ + "img/GS_Profile-Kamogelo Masilo.a78a3a57.png";